// removed by extract-text-webpack-plugin
module.exports = {"root":"show-rating__root"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/show-rating/styles.less
// module id = 473
// module chunks = 1